import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export interface PdfInfo {
  source: string;
  order: string;
}

interface MergePdfsPayload {
  pdf_info: PdfInfo[];
}

export interface MergePdfsResponse {
  blob: Blob; // Binary PDF blob
  success: boolean;
}

export const mergePdfs = async (
  pdfInfo: PdfInfo[],
  signal?: AbortSignal,
): Promise<MergePdfsResponse> => {
  try {
    const token = await getBearerToken();

    const payload: MergePdfsPayload = {
      pdf_info: pdfInfo,
    };

    const response = await fetch(API_ENDPOINTS.MERGE_PDFS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
      signal,
    });

    if (!response.ok) {
      const errorData = await response.text().catch(() => "");
      throw new Error(
        `Request failed with status ${response.status}: ${errorData || response.statusText}`,
      );
    }

    // The API returns the PDF file directly as binary data
    const blob = await response.blob();

    return {
      blob,
      success: true,
    };
  } catch (error) {
    logDataToConsole("error in mergePdfs", error);
    throw error;
  }
};
